import React from "react";
import { Crown } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Мала корона поряд з текстом кнопки (inline)
export function CrownIcon({ className = "" }) {
  return <Crown className={`w-3.5 h-3.5 text-amber-500 ${className}`} aria-hidden="true" />;
}

// Clickable-оверлей поверх заблокованого блоку (напр. тіпси): блюр + корона по центру.
// Клік -> /subscription
export function LockOverlay({ children, label, blur = true }) {
  const navigate = useNavigate();
  return (
    <div
      className="relative cursor-pointer"
      onClick={() => navigate("/subscription")}
      role="button"
      tabIndex={0}
    >
      <div className={`pointer-events-none select-none ${blur ? "blur-sm opacity-60" : "opacity-40"}`}>{children}</div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
        <Crown className="w-8 h-8 text-amber-500" aria-hidden="true" />
        {label ? <span className="text-sm font-medium text-black/70">{label}</span> : null}
      </div>
    </div>
  );
}
